import { render, staticRenderFns } from "./AboutAndPrivacy.vue?vue&type=template&id=00e9a641&scoped=true"
import script from "./AboutAndPrivacy.vue?vue&type=script&lang=js"
export * from "./AboutAndPrivacy.vue?vue&type=script&lang=js"
import style0 from "./AboutAndPrivacy.vue?vue&type=style&index=0&id=00e9a641&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e9a641",
  null
  
)

export default component.exports